module.exports = __webpack_public_path__ + "static/media/PONTEIRA_DOSADORA_LEQUE.e5761c70.png";